export default __webpack_public_path__ + "static/media/web_screenshot_2.02a36511.png";